export const defaultGroup = {
  groupId: "Group_1",
  groupName: "Group_1",
};
